import React from 'react'
import { Modal } from 'react-bootstrap'
import SearchForm from './SearchForm'

const ModalSearchForm = ({ showSearch, fullscreen = true, setShowSearch, categoryData, Title = null }) => {
	return (
		<Modal show={showSearch} fullscreen={'sm-down'} onHide={() => setShowSearch(false)}>
			{Title && (
				<Modal.Header closeButton>
					<Modal.Title>Modal</Modal.Title>
				</Modal.Header>
			)}
			<Modal.Body>
				<SearchForm showSearch={showSearch} setShowSearch={setShowSearch} categoryData={categoryData} modalCss={true} />
			</Modal.Body>
		</Modal>
	)
}

export default ModalSearchForm
